import { verticalAutoSlider } from "./vertical-auto-slider";

export const initLister = () => {
    initFilter();
    const uspBar = document.querySelectorAll(".usp-bar");
    if (uspBar) {
        uspBar.forEach((el) => {
            verticalAutoSlider(el, {
                startWidth: 1024,
                interval: 4000,
                speed: 1500,
            });
        });
    }
};

function preventEmptyS() {
    s = document.querySelector(".filter #s");
    if (s.value == "") {
        s.setAttribute("disabled", "disabled");
    }
}

function initFilter() {
    let form = document.getElementById("filter-form");

    if (form) {
        form.addEventListener("keydown", function (event) {
            if (event.key === "Enter") {
                preventEmptyS();
                form.submit();
            }
        });

        form.querySelectorAll(".filter-field").forEach((field) => {
            field.addEventListener("change", function () {
                document.getElementById("l").value = field.dataset.key;
                const term_id = field.dataset.term_id;
                document
                    .querySelectorAll(".parent_" + term_id)
                    .forEach((el) => {
                        el.checked = false;
                    });
                preventEmptyS();

                if (!tryFilterNavigation()) {

                    form.submit();
                }

            });
        });

        form.querySelectorAll(".search-filter").forEach((field) => {
            initSearchable(field);
        });

        form.querySelectorAll(".show-more").forEach((link) => {
            link.addEventListener("click", function (event) {
                event.currentTarget.classList.toggle("closed");
                toggleInnerText(event.currentTarget.querySelector("span"), [
                    "toon meer",
                    "toon minder",
                ]);
                event.currentTarget.previousElementSibling.classList.toggle(
                    "hidden",
                );
                event.preventDefault();
            });
        });

        document
            .querySelector(".remove-s")
            ?.addEventListener("click", function (event) {
                form.querySelector("#s").remove()
                form.submit();
            });
        /*
        document.querySelectorAll(".tag-remove").forEach((link) => {
            link.addEventListener("click", function (event) {
                const forId = link.getAttribute("for");
                const filterBox = document.getElementById(forId);
                if (filterBox == null) {
                    form.submit();
                }
                event.preventDefault();
            });
        });
        */
    }
}

function tryFilterNavigation() {
    if (follow_category_path) {
        let form = document.getElementById("filter-form");
        let paths = [];
        let depths_counter = []
        form.querySelectorAll(".filter-field:checked").forEach((field) => {
            let depth = field.dataset.depth
            depths_counter[depth] = (depths_counter[depth] || 0) + 1;
            paths.push({ 'value': field.value, 'depth': Number(depth) });

        });

        if (paths.length == 0) {
            return false;
        }

        for (let i = 0; i < depths_counter.length; i++) {
            if (depths_counter[i] > 1) {
                return false;
            }
        }
        const filter_url = paths.map((el) => {
            return el.value;
        }).join("/");
        window.location.href = window.location.origin + "/" + filter_url;
        return true;

    }

    return false;
}

function initSearchable(field) {
    const optionsContainer = document.querySelector(
        ".searchable-" + field.dataset.search,
    );

    field.parentNode.querySelector(".clear").addEventListener("click", () => {
        field.value = "";
        field.dispatchEvent(new Event("keyup"));
    });

    function filterOptions() {
        const searchValue = field.value.toLowerCase();
        const options = optionsContainer.querySelectorAll(".option");
        optionsContainer.classList.toggle("searching", searchValue != "");
        field.parentNode.classList.toggle("searching", searchValue != "");

        let num_found = 0;
        options.forEach((option) => {
            const optionText = option.dataset.title.toLowerCase();
            if (optionText.includes(searchValue) || searchValue == "") {
                option.style.display = "flex";
                num_found++;
            } else {
                option.style.display = "none";
            }
        });

        optionsContainer.classList.toggle("nothing", num_found == 0);
    }

    // Add event listener to search input
    field.addEventListener("keyup", filterOptions);
}
